import React, { Fragment } from 'react';

export const getHighlightedText = (text: string, higlight: string, color = '#FAAD14') => {
  // Split text on higlight term, include term itself into parts, ignore case
  const parts = text.split(new RegExp(`(${higlight})`, 'gi'));

  return parts.map((part, i) => (
    <Fragment key={i}>
      {part.toLowerCase() === higlight.toLowerCase() ? (
        <b
          style={{
            color: color,
            fontWeight: 600,
          }}
        >
          {part}
        </b>
      ) : (
        part
      )}
    </Fragment>
  ));
};
